/**
 * 時分入力（24時間以上）フォームを初期化
 */
 window.initialize_input = function() {

    /*---- 半角入力フォームの初期化 ----*/

    $(document).on('compositionend', '.harf-char-input', function(e) {
        let half = $(this).val().replace(/[！-～]/g, function(str) {
            return String.fromCharCode(str.charCodeAt(0) - 0xFEE0);
        }).replace(/”/g, "\"")
        .replace(/’/g, "'")
        .replace(/‘/g, "`")
        .replace(/￥/g, "\\")
        .replace(/　/g, " ")
        .replace(/〜/g, "~");
        $(this).val(half.replace(/[^0-9|:]+/i,''));
    });
}

/**
 * ツールチップを初期化
 */
window.initialize_tooltip = function() {
    // ツールチップを初期化
    $('[data-toggle="tooltip"]').tooltip();
}
/**
 * select2を初期化
 */
window.initialize_select2 = function() {
    // select2を初期化
    $('select.select2').each(function() {
        let noResults = $(this).data('no-results');
        $(this).select2({
            width: "100%",
            language: { "noResults": function() {
                return noResults;
            }},
        });
    });

    // select2のopen時に選択項目エリアの高さを調整する
    $(document).on('select2:open', function () {
        // ブラウザビューポートの高さを取得
        let windowHeight = $(window).height();
        // ドロップダウンの要素（ulリスト部分）を取得
        let $results = $('.select2-results__options');
        let adjusted = $results.data('adjusted') ?? 0;

        if (windowHeight < 280) {
            if ($results.length && windowHeight !== adjusted) {
                // ドロップダウンの画面上の「上端の位置」を取得
                const offsetTop = $results.offset().top;

                // スクロール量を取得
                const scrollTop = $(window).scrollTop();

                // ウインドウ下端までの残り（余白として20px引く）
                const availableHeight = windowHeight - (offsetTop - scrollTop) - 20;

                // 計算した高さをmax-heightとして動的に適用（最低でも50pxは確保）
                const maxHeight = Math.max(availableHeight, 50);

                $results.css('max-height', maxHeight + 'px').attr('data-adjusted', windowHeight);
            }
        } else {
            $results.css('max-height', '');
        }
    });

    // モーダル上のselect2をopenした時は、bootstrapのフォーカス強制を一時的に無効にする
    $('.modal').on('select2:open', function() {
        $(document).off('focusin.modal');
    });
    // フォーカスをモーダルに戻せば、フォーカス強制は初期化される
    $('.modal').on('select2:close', function() {
        $(this).parent('.modal').trigger('focus');
    });

    // 親の更新処理
    function parentSelectUpdate(elm, selector) {
        let parent = $(elm).parents('form').find(selector);
        if ($(elm).val() == '' && $(parent).val() != '') {
            $(parent).trigger('change');
        }
    }
    // nullで保存している場合の初期値の取得処理（親がform内に存在している場合に更新を行う）
    $('select.company-select').each(function() {
        parentSelectUpdate(this, 'select.holding-select');
    });
    $('select.section-select').each(function() {
        parentSelectUpdate(this, 'select.company-select');
    });
    $('select.user-select').each(function() {
        parentSelectUpdate(this, 'select.section-select');
    });
    $('select.driver-select').each(function() {
        parentSelectUpdate(this, 'select.section-select');
    });
    $('select.account-user-select').each(function() {
        parentSelectUpdate(this, 'select.section-select');
    });
    // $('select.rollcall-assistant-select').each(function() {
    //     parentSelectUpdate(this, 'select.section-select');
    // });
    // $('select.rollcall-enforcer-select').each(function() {
    //     parentSelectUpdate(this, 'select.section-select');
    // });
    // $('select.rollcall-authorizer-select').each(function() {
    //     parentSelectUpdate(this, 'select.section-select');
    // });
    $('select.vehicle-select').each(function() {
        parentSelectUpdate(this, 'select.section-select');
    });
}
/**
 * マルチセレクトを初期化
 */
 window.initialize_multiselect = function() {
    // マルチセレクトを初期化
    $('select.multi-select').each(function() {
        // `drive_recorder.index` では検索フォームにマルチセレクトが存在します。
        // 同一画面内でモーダルを開くと `initialize()` が再実行され、
        // 検索フォームのマルチセレクトが再初期化されてしまいます。
        //
        // `multiple-select` は同一要素への複数回初期化に対応していないため、
        // 再初期化されると DOM やイベントが二重化され、挙動が破壊されます。
        //
        // そのため、この画面に限り既存インスタンスを `destroy` してから
        // 再初期化するようにしています。
        // 他画面への影響を避けるため、`is_route('drive_recorder.index')` 内に限定します。
        if (is_route('drive_recorder.index')) {
            const $element = $(this);

            if ($element.data('multipleSelect')) {
                $element.multipleSelect('destroy');
            }
        }

        let noResults = $(this).data('no-results');
        let countSelected = $(this).data('count-selected');
        let allSelect = $(this).data('all-select');
        let allSelected = $(this).data('all-selected');
        $(this).multipleSelect({
            formatSelectAll: function () {
                return allSelect;
            },
            formatAllSelected: function () {
                return allSelected;
            },
            formatNoMatchesFound: function () {
                return noResults;
            },
            formatCountSelected: function (count, total) {
                return countSelected.replace(':count', count).replace(':total', total);
            }
        });
    });
}
/**
 * ツリービューを初期化
 */
window.initialize_treemultiselect = function() {
    let treemultiselect = [];
    $('select.tree-multiselect').each(function() {
        let search = $(this).data('search');
        let openAll = $(this).data('open-all');
        let closeAll = $(this).data('close-all');
        let selectAll = $(this).data('select-all');
        let unselectAll = $(this).data('unselect-all');
        treemultiselect.push(
            $(this).treeMultiselect({
                searchable: true,
                enableSelectAll: true,
                // sortable: true,
                startCollapsed: false,
                sectionDelimiter: '|',
                hideSidePanel: false,
                searchText: search,
                openAllText: openAll,
                closeAllText: closeAll,
                selectAllText: selectAll,
                unselectAllText: unselectAll,
            })
        );
        $('.search').attr('placeholder', search);
    });
    return treemultiselect;
}
/**
 * デートピッカーを初期化
 * @param {*} type all, time-minutes, time-seconds, date, datetime, datetime-seconds, month, year
 */
window.initialize_datepicker = function(type = 'all') {

    /*---- 時分選択フォームの初期化 ----*/

    if (type == 'all' || type == 'time-minutes') {
        $('.time-minutes-picker').each(function() {
            var display_viewMode = ($(this).data('display-viewmode') ? $(this).data('display-viewmode') : 'times');
            var stepping = ($(this).data('stepping') ? $(this).data('stepping') : 1);
            $(this).datetimepicker({
                datepicker: false,
                format: 'HH:mm',
                viewMode: display_viewMode,
                locale: 'ja',
                stepping: stepping,
                icons: {
                    time: 'far fa-clock',
                }
            });
            $(this).off('focus');
            $(this).on('focus', function() {
                $(this).datetimepicker('show');
            });
            $(this).off('blur');
            $(this).on('blur', function() {
                $(this).datetimepicker('hide');
            });
            $(this).off('change.datetimepicker');
            $(this).on('change.datetimepicker', function(e){
                let id = create_id($(this).data('id'));
                if ($(this).data('type') == 'int') {
                    let values = $(this).val().split(':');
                    let minutes = (Number(values[0]) * 60) + (Number(values[1]));
                    $(id).val(minutes);
                } else {
                    $(id).val($(this).val());
                }
            });
        });
    }

    /*---- 時間選択フォームの初期化 ----*/

    if (type == 'all' || type == 'time-seconds') {
        $('.time-seconds-picker').each(function() {
            var display_viewMode = ($(this).data('display-viewmode') ? $(this).data('display-viewmode') : 'times');
            var stepping = ($(this).data('stepping') ? $(this).data('stepping') : 1);
            $(this).datetimepicker({
                datepicker: false,
                format: 'H:mm:ss',
                viewMode: display_viewMode,
                locale: 'ja',
                stepping: stepping,
                icons: {
                    time: 'far fa-clock',
                }
            });
            $(this).off('focus');
            $(this).on('focus', function() {
                $(this).datetimepicker('show');
            });
            $(this).off('blur');
            $(this).on('blur', function() {
                $(this).datetimepicker('hide');
            });
            $(this).off('change.datetimepicker');
            $(this).on('change.datetimepicker', function(e){
                let id = create_id($(this).data('id'));
                if ($(this).data('type') == 'int') {
                    let values = $(this).val().split(':');
                    let seconds = (Number(values[0]) * 60 * 60) + (Number(values[1]) * 60) + Number(values[2]);
                    $(id).val(seconds);
                } else {
                    $(id).val($(this).val());
                }
            });
        });
    }

    /*---- 日付選択フォームの初期化 ----*/

    if (type == 'all' || type == 'date') {
        $('.date-picker').each(function() {
            var display_viewMode = ($(this).data('display-viewmode') ? $(this).data('display-viewmode') : 'days');
            $(this).datetimepicker({
                format: 'YYYY/MM/DD',
                viewMode: display_viewMode,
                locale: 'ja',
                dayViewHeaderFormat: 'YYYY年 MM月',
                icons: {
                    time: 'far fa-clock',
                }
            });
            $(this).off('focus');
            $(this).on('focus', function() {
                // 値を取得
                let value = $(this).val();
                $(this).datetimepicker('show');
                // 元の値が空欄の場合はカレンダーの表示時に値を与えない
                if (value == '') {
                    $(this).val('')
                }
            });
            $(this).off('blur');
            $(this).on('blur', function() {
                $(this).datetimepicker('hide');
            });
            $(this).off('change.datetimepicker');
            $(this).on('change.datetimepicker', function(e){
                // 変更前の値がない場合かつ変更されている場合にイベントを発行
                if (e.oldDate != null && e.oldDate != e.date) {
                    $(this).trigger('change');
                }
            });
        });
    }

    /*---- 日時選択フォームの初期化 ----*/

    if (type == 'all' || type == 'datetime') {
        $('.datetime-picker').each(function() {
            var display_viewMode = ($(this).data('display-viewmode') ? $(this).data('display-viewmode') : 'days');
            var stepping = ($(this).data('stepping') ? $(this).data('stepping') : 1);
            $(this).datetimepicker({
                format: 'YYYY/MM/DD HH:mm',
                viewMode: display_viewMode,
                locale: 'ja',
                dayViewHeaderFormat: 'YYYY年 MM月',
                stepping: stepping,
                icons: {
                    time: 'far fa-clock',
                }
            });
            $(this).off('focus');
            $(this).on('focus', function() {
                // 値を取得
                let value = $(this).val();
                $(this).datetimepicker('show');
                // 元の値が空欄の場合はカレンダーの表示時に値を与えない
                if (value == '') {
                    $(this).val('')
                }
            });
            $(this).off('blur');
            $(this).on('blur', function(e) {
                $(this).datetimepicker('hide');
            });
            $(this).off('change.datetimepicker');
            $(this).on('change.datetimepicker', function(e){
                // 変更後のvalue値を更新する
                $('input[name="'+$(this).attr('name')+'"]').val($(this).val());
                $(this).attr('value', $(this).val());
                // 変更前の値がない場合かつ変更されている場合にイベントを発行
                if (e.oldDate != null && e.oldDate != e.date) {
                    $(this).data('old-timestamp', e.oldDate.unix());
                    $(this).trigger('change');
                }
            });
        });
    }

    /*---- 日時（秒）選択フォームの初期化 ----*/

    if (type == 'all' || type == 'datetime-seconds') {
        $('.datetime-seconds-picker').each(function() {
            var display_viewMode = ($(this).data('display-viewmode') ? $(this).data('display-viewmode') : 'days');
            var stepping = ($(this).data('stepping') ? $(this).data('stepping') : 1);
            $(this).datetimepicker({
                format: 'YYYY/MM/DD HH:mm:ss',
                viewMode: display_viewMode,
                locale: 'ja',
                dayViewHeaderFormat: 'YYYY年 MM月',
                stepping: stepping,
                icons: {
                    time: 'far fa-clock',
                }
            });
            $(this).off('focus');
            $(this).on('focus', function() {
                // 値を取得
                let value = $(this).val();
                $(this).datetimepicker('show');
                // 元の値が空欄の場合はカレンダーの表示時に値を与えない
                if (value == '') {
                    $(this).val('')
                }
            });
            $(this).off('blur');
            $(this).on('blur', function(e) {
                $(this).datetimepicker('hide');
            });
            $(this).off('change.datetimepicker');
            $(this).on('change.datetimepicker', function(e){
                // 変更前の値がない場合かつ変更されている場合にイベントを発行
                if (e.oldDate != null && e.oldDate != e.date) {
                    $(this).data('old-timestamp', e.oldDate.unix());
                    let id = create_id($(this).data('id'));
                    $(id).val($(this).val());
                    $(this).trigger('change');
                }
            });
        })
    }

    /*---- 月選択フォームの初期化 ----*/

    if (type == 'all' || type == 'month') {
        $('.month-picker').each(function() {
            var display_format = ($(this).data('display-format') ? $(this).data('display-format') : 'M');
            var name = $(this).data('target-name');
            if ($('input[name=' + name + ']').val() != '') {
                $(this).val(moment($('input[name=' + name + ']').val()).format(display_format));
            }
            $(this).off('changeDate');
            $(this).off('blur');
            var orientation = $(this).attr('id') === 'search-form-month' ? "bottom" : "auto";
            $(this).datepicker({
                format: display_format.toLowerCase(),
                language: 'ja',
                autoclose: true,
                minViewMode: 'months',
                orientation: orientation,
            }).on('changeDate', function(e) {
                $('input[name=' + name + ']').val(moment(e.dates[0]).format('YYYY-MM'));
            }).on('blur', function(e) {
                if ($('input[name=' + name + ']').val() != '') {
                    $(this).val(moment($('input[name=' + name + ']').val()).format(display_format));
                }
            });
        });
        $('.month-picker-inputs a.back').off('click');
        $('.month-picker-inputs a.back').on('click', function () {
            month_picker_inputs_action(this, 'subtract');
        });
        $('.month-picker-inputs a.forward').off('click');
        $('.month-picker-inputs a.forward').on('click', function () {
            month_picker_inputs_action(this, 'add');
        });
        $('.month-picker-inputs a.current').off('click');
        $('.month-picker-inputs a.current').on('click', function () {
            month_picker_inputs_action(this, 'current');
        });
        function month_picker_inputs_action(elm, type)
        {
            let picker = $(elm).parent().find('.month-picker');
            let input = $(elm).parent().find('.month-picker-value');
            let display_format = ($(picker).data('display-format') ? $(picker).data('display-format') : 'M');
            let value = input.val();
            let update = moment();
            switch(type) {
                case 'subtract':
                    update = moment(value).subtract(1, 'months');
                    break;
                case 'add':
                    update = moment(value).add(1, 'months');
                    break;
            }
            $(elm).parent().find('.month-picker').val(update.format(display_format));
            $(elm).parent().find('.month-picker-value').val(update.format('YYYY-MM')).trigger('change');
        }
    }

    /*---- 年選択フォームの初期化 ----*/

    if (type == 'all' || type == 'year') {
        $('.year-picker').each(function() {
            var display_format = ($(this).data('display-format') ? $(this).data('display-format') : 'YYYY');
            var name = $(this).data('target-name');
            $(this).val(moment($('input[name=' + name + ']').val()).format(display_format));
            $(this).off('changeDate');
            $(this).off('blur');
            $(this).datepicker({
                format: display_format.toLowerCase(),
                language: 'ja',
                autoclose: true,
                minViewMode: 'years',
            }).on('changeDate', function(e) {
                $('input[name=' + name + ']').val(moment(e.dates[0]).format('YYYY'));
            }).on('blur', function(e) {
                $(this).val(moment($('input[name=' + name + ']').val()).format(display_format));
            });
        });
        $('.year-picker-inputs a.back').off('click');
        $('.year-picker-inputs a.back').on('click', function () {
            year_picker_inputs_action(this, 'subtract');
        });
        $('.year-picker-inputs a.forward').off('click');
        $('.year-picker-inputs a.forward').on('click', function () {
            year_picker_inputs_action(this, 'add');
        });
        $('.year-picker-inputs a.current').off('click');
        $('.year-picker-inputs a.current').on('click', function () {
            year_picker_inputs_action(this, 'current');
        });
        function year_picker_inputs_action(elm, type)
        {
            let picker = $(elm).parent().find('.year-picker');
            let input = $(elm).parent().find('.year-picker-value');
            let display_format = ($(picker).data('display-format') ? $(picker).data('display-format') : 'YYYY');
            let value = input.val();
            let update = moment();
            switch(type) {
                case 'subtract':
                    update = moment(value).subtract(1, 'years');
                    break;
                case 'add':
                    update = moment(value).add(1, 'years');
                    break;
            }
            $(elm).parent().find('.year-picker').val(update.format(display_format));
            $(elm).parent().find('.year-picker-value').val(update.format('YYYY')).trigger('change');
        }
    }


}
/**
 * スイッチフォームを初期化
 */
 window.initialize_switchflag = function() {
    // スイッチフォームを初期化
    $('.switch-flag').each(function() {
        switch_flag_action(this);
        $(document).off('change', '.switch-flag');
        $(document).on('change', '.switch-flag', function() {
            switch_flag_action(this);
        });
    });
    // スイッチ変更時の処理
    function switch_flag_action(elm) {
        let selector = $(elm).data('disabled');
        if ($(elm).prop('checked')) {
            $(selector).prop('disabled', false);
        } else {
            $(selector).prop('disabled', true);
        }
    }
}
/**
 * データテーブルを初期化
 */
 window.initialize_datatable = function() {
    //     $(this).dataTable({
    //         // 初期表示時には並び替えをしない
    //         order: [],
    //         // 件数切替機能 無効
    //         lengthChange: false,
    //         // 検索機能 無効
    //         searching: false,
    //         // ソート機能 無効
    //         ordering: true,
    //         // 情報表示 無効
    //         info: false,
    //         // ページング機能 無効
    //         paging: false
    //     });
    // });
}

/**
 * 要素をマウス操作で並び替え
 */
window.initialize_sortable = function() {

    // 要素をマウス操作で並び替え
    $( "#sortable" ).sortable();
}

/**
 * 共通の禁止操作や初期化処理などを設定する。
 * @param {*} type all, tooltip, select2, multiselect, datepicker
 */
window.initialize = function (type = 'all') {

    /*---- 入力系フォームの初期化 ----*/
    if (type == 'all' || type == 'input') {
        initialize_input();
    }

    /*---- ツールチップの有効化 ----*/

    if (type == 'all' || type == 'tooltip') {
        initialize_tooltip();
    }

    initialize_sortable();

    /*---- セレクト２を初期化 ----*/

    if (type == 'all' || type == 'select2') {
        initialize_select2();
    }

    /*---- マルチセレクトを初期化 ----*/

    if (type == 'all' || type == 'multiselect') {
        initialize_multiselect();
    }

    /*---- 時分選択フォームの初期化 ----*/

    if (type == 'all' || type == 'datepicker') {
        initialize_datepicker('time-minutes');
    }

    /*---- 時間選択フォームの初期化 ----*/

    if (type == 'all' || type == 'datepicker') {
        initialize_datepicker('time-seconds');
    }

    /*---- 日付選択フォームの初期化 ----*/

    if (type == 'all' || type == 'datepicker') {
        initialize_datepicker('date');
    }

    /*---- 日時選択フォームの初期化 ----*/

    if (type == 'all' || type == 'datepicker') {
        initialize_datepicker('datetime');
    }

    /*---- 日時（秒）選択フォームの初期化 ----*/

    if (type == 'all' || type == 'datepicker') {
        initialize_datepicker('datetime-seconds');
    }

    /*---- 月選択フォームの初期化 ----*/

    if (type == 'all' || type == 'datepicker') {
        initialize_datepicker('month');
    }

    /*---- 年選択フォームの初期化 ----*/

    if (type == 'all' || type == 'datepicker') {
        initialize_datepicker('year');
    }

    /*---- スイッチフォームの初期化 ----*/

    if (type == 'all' || type == 'switchflag') {
        initialize_switchflag();
    }

    /*---- テーブルの初期化 ----*/

    if (type == 'all' || type == 'datatable') {
        initialize_datatable();
    }

    /*---- その他の制御 ----*/

    if (type == 'all') {

        /*---- フォームの直接のサブミットを禁止 ----*/

        $(document).off('submit', '#search-form:not([data-force-send=true])');
        $(document).on('submit', '#search-form:not([data-force-send=true])', function() {
            return false;
        });

        /*---- backdropクリックで閉じないように修正 ----*/

        $.each($('.modal'), function() {
            if ($(this).data('backdrop') == null) {
                $(this).data('backdrop', 'static');
            }
        });

        /*---- モーダルの表示時にスクロールをトップに変更 ----*/

        $(document).off('shown.bs.modal', '.modal');
        $(document).on('show.bs.modal', '.modal', function (e) {
            $(this).find('.modal-body').scrollTop(0);
        });

        /*---- モーダルの重複表示 ----*/

        $(document).on('show.bs.modal', '.modal', function (e) {
            var currentModal = $(e.currentTarget);
            var zIndex = 1040 + (10 * $('.modal:visible').length);
            currentModal.css('z-index', zIndex);
            setTimeout(function() {
                $('.modal-backdrop')
                    .not('.modal-stack')
                    .css('z-index', zIndex - 1)
                    .addClass('modal-stack');
            }, 0);
        });

        $(document).off('keydown', 'form');
        $(document).on('keydown', 'form', function (e) {
            if (e.key == 'Tab') {
                /*---- フォーム操作時のフォーム外へのtab移動制限 ----*/
                let inputs = $(this).find('input:visible, textarea:visible, select:visible, button:visible').not(':disabled');
                let focused = $(this).find(':focus')[0];
                for(i = 0; i < inputs.length; i ++) {
                    if (focused == inputs[i]) {
                        break;
                    }
                }
                if (e.shiftKey) {
                    i --;
                } else {
                    i ++;
                }
                if (i >= inputs.length) {
                    e.preventDefault();
                    $(inputs[0]).trigger('focus');
                } else if (i < 0) {
                    e.preventDefault();
                    $(inputs[inputs.length - 1]).trigger('focus');
                }
            }else if(e.key == 'Enter'){
                /*---- フォームの直接のサブミットを禁止 ----*/
                var current = document.activeElement;
                if ($(current).is("input")){
                    return false;
                }
            }
        });
    }
}
/**
 * 各ページ表示時に呼出
 */
$(function () {
    //コンテンツの読込
    load_contents();
    // //サイドバーに表示するお知らせカウントの非同期取得
    // if (is_route('user.login') || is_route('setup.index') || is_route('dashboard.index')){
    //     //ログイン・セットアップページはお知らせカウントを取得しない
    //     //ダッシュボードはお知らせ更新する際に設定するため、ここで取得しない
    // }else{
    //     sidebar_information_load($('#menu-item-user'));
    //     sidebar_information_load($('#menu-item-vehicle'));
    //     sidebar_information_load($('#menu-item-measurement'));
    //     sidebar_information_load($('#menu-item-device'));
    // }
});
